import InvoicesTableView from './invoicesTableView';

export default InvoicesTableView;
